import { message } from "antd";
import React, { useEffect, useState, useCallback } from "react";
import variableLanguage from "../../../utils/hooks/hookGetVariablesLanguage";
import requests from "../../../axios/requests";
import { SimpleEditor } from "../CourseEditorTeacher";

const CreateOrEditArticle = (props) => {
  const {
    stage_id,
    propsSetView,
    createArticle,
    editArticle,
    isEditComponent = false,
  } = props;

  const variable_3 = variableLanguage({
    keyPage: "courseManageEditLesson",
    keyVariable: "variable_3",
  });
  const variable_18 = variableLanguage({
    keyPage: "courseManageEditLesson",
    keyVariable: "variable_18",
  });
  const variable_24 = variableLanguage({
    keyPage: "courseManageEditLesson",
    keyVariable: "variable_24",
  });
  const variable_26 = variableLanguage({
    keyPage: "courseManageEditLesson",
    keyVariable: "variable_26",
  });
  const variable_33 = variableLanguage({
    keyPage: "courseManageEditLesson",
    keyVariable: "variable_33",
  });
  const variable_34 = variableLanguage({
    keyPage: "courseManageEditLesson",
    keyVariable: "variable_34",
  });
  const variable_37 = variableLanguage({
    keyPage: "courseManageEditLesson",
    keyVariable: "variable_37",
  });
  const variable_92 = variableLanguage({
    keyPage: "courseManageEditLesson",
    keyVariable: "variable_92",
  });
  const variable_93 = variableLanguage({
    keyPage: "courseManageEditLesson",
    keyVariable: "variable_93",
  });

  const [valuesObject, setValuesObject] = useState(() => {
    const items = props.stageItems;
    return items
      ? { ...items, stage: stage_id, theory_type: "A" }
      : { stage: stage_id, theory_type: "A", title: "", text: "", url_refs: "" };
  });
  const [editorImageKey, setEditorImageKey] = useState("");
  const [editorFileKey, setEditorFileKey] = useState("");

  useEffect(() => {
    requests.storage.get_yandex_key({ stage_id, theory_type: "A" })
      .then((res) => setEditorImageKey(res.data.key));
    requests.storage.get_yandex_key({ stage_id, theory_type: "A" })
      .then((res) => setEditorFileKey(res.data.key));
  }, [stage_id]);

  useEffect(() => {
    if (props.stageItems !== undefined) {
      setValuesObject(props.stageItems);
    }
  }, [props.stageItems]);

  const handleEditorImageUpload = useCallback(async (file, onProgress) => {
    if (!editorImageKey) {
      throw new Error("Ключ хранилища не загружен");
    }
    const key = editorImageKey + "/" + file.name.replace(/\s+/g, "_");
    await requests.storage.storage_upload(key, file, (progress) => {
      const percent = Math.round((progress.loaded * 100) / progress.total);
      onProgress?.({ progress: percent });
    }, "image/*");
    return `https://skillometer.ru/storage/${key}`;
  }, [editorImageKey]);

  const handleEditorFileUpload = useCallback(async (file, onProgress) => {
    if (!editorFileKey) {
      throw new Error("Ключ хранилища не загружен");
    }
    const key = editorFileKey + "/" + file.name.replace(/\s+/g, "_");
    await requests.storage.storage_upload(key, file, (progress) => {
      const percent = Math.round((progress.loaded * 100) / progress.total);
      onProgress?.({ progress: percent });
    });
    return `https://skillometer.ru/storage/${key}`;
  }, [editorFileKey]);
  return (
    <>
      <div className="label">{variable_24}</div>
      <input
        value={valuesObject.title}
        onChange={(e) =>
          setValuesObject((prev) => ({ ...prev, ["title"]: e.target.value }))
        }
        placeholder={variable_26}
        maxLength={99}
      />
      <div className="label">{variable_92}</div>
      <SimpleEditor
        value={valuesObject.text}
        onChange={(html) => setValuesObject((prev) => ({ ...prev, text: html }))}
        placeholder={variable_93}
        className="auto-height-editor"
        onImageUpload={handleEditorImageUpload}
        onImageUploadError={(error) => message.error(error.message)}
        onFileUpload={handleEditorFileUpload}
        onFileUploadError={(error) => message.error(error.message)}
      />
      <div className="label">{variable_37}</div>
      <input
        value={valuesObject.url_refs}
        onChange={(e) =>
          setValuesObject((prev) => ({ ...prev, ["url_refs"]: e.target.value }))
        }
        placeholder={variable_26}
      />
      <div className="group_buttons">
        <div
          className="btn_save"
          onClick={() => {
            if (!valuesObject.title) return message.error(variable_3);
            if (isEditComponent) {
              valuesObject.stage = stage_id;
              return editArticle(valuesObject);
            }
            createArticle(valuesObject);
          }}
        >
          {isEditComponent ? variable_33 : variable_18}
        </div>
        <div className="btn_cansel btn_save" onClick={() => propsSetView()}>
          {variable_34}
        </div>
      </div>
    </>
  );
};

export default CreateOrEditArticle;
